let isOfficial;
const reg = (/emergency/).test(window.location.hostname);
if(reg){//官网
    isOfficial = true
}else{//机构
    isOfficial = false
}
export default  isOfficial